import { config } from './config';

/** Прочитать значение cookie по имени (для double-submit CSRF). */
function readCookie(name: string): string | null {
  for (const part of document.cookie.split(';')) {
    const trimmed = part.trim();
    const eq = trimmed.indexOf('=');
    if (eq < 0) continue;
    if (trimmed.slice(0, eq) === name) {
      return decodeURIComponent(trimmed.slice(eq + 1));
    }
  }
  return null;
}

const CSRF_COOKIE = 'XSRF-TOKEN';
const CSRF_HEADER = 'X-XSRF-TOKEN';
const MUTATING = new Set(['POST', 'PUT', 'PATCH', 'DELETE']);

/**
 * Тонкая обёртка над fetch: проставляет credentials (cookie-сессия), Accept,
 * и для мутирующих методов — CSRF-заголовок (double-submit, ADR-021).
 */
export async function apiFetch(path: string, init: RequestInit = {}): Promise<Response> {
  const method = (init.method ?? 'GET').toUpperCase();
  const headers = new Headers(init.headers);
  headers.set('Accept', 'application/json');

  if (MUTATING.has(method)) {
    let token = readCookie(CSRF_COOKIE);
    if (!token) {
      // Лениво получаем CSRF-токен у bff (выставляет cookie + возвращает значение).
      await fetch(`${config.apiBase}/api/v1/csrf`, { credentials: 'include' });
      token = readCookie(CSRF_COOKIE);
    }
    if (token) {
      headers.set(CSRF_HEADER, token);
    }
  }

  return fetch(`${config.apiBase}${path}`, {
    ...init,
    method,
    headers,
    credentials: 'include',
  });
}
